import { render, staticRenderFns } from "./Divisiveness.vue?vue&type=template&id=9de56998&scoped=true"
import script from "./Divisiveness.vue?vue&type=script&lang=js"
export * from "./Divisiveness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de56998",
  null
  
)

export default component.exports